import { render, staticRenderFns } from "./PatientAppointments.vue?vue&type=template&id=3677b5ee&"
import script from "./PatientAppointments.vue?vue&type=script&lang=js&"
export * from "./PatientAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports